import { render } from "./FloatingAIAssistant.vue?vue&type=template&id=bab9c324&scoped=true"
import script from "./FloatingAIAssistant.vue?vue&type=script&lang=js"
export * from "./FloatingAIAssistant.vue?vue&type=script&lang=js"

import "./FloatingAIAssistant.vue?vue&type=style&index=0&id=bab9c324&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bab9c324"]])

export default __exports__